import { useNavigate, useLocation, useParams } from 'react-router-dom';
import * as React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Tab, TabList, TabPanel, Tabs as CarbonTabs } from 'carbon-react/lib/components/tabs/__next__';

import { ROUTES, getCOABalanceSheetRoute, getCOAProfitAndLossRoute } from '@futrli/shared-services';

import { useNavHeight } from '../../../hooks/useNavHeight';

import * as styles from './tabs.scss';

const PROFIT_LOSS_TAB_ID = ROUTES.PROFIT_AND_LOSS;
const BALANCE_SHEET_TAB_ID = ROUTES.BALANCE_SHEET;

const TABS_PADDING_PLUS_BORDER = 8;

export const TABS_HEIGHT = 40;

export const Tabs = () => {
  const { pathname } = useLocation();
  const intl = useIntl();

  const isBalanceSheet = pathname.indexOf(ROUTES.BALANCE_SHEET) !== -1;

  const navigate = useNavigate();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';
  const { navHeight } = useNavHeight();

  const handleCarbonTabChange = React.useCallback(
    (tabId: string) => {
      if (tabId === BALANCE_SHEET_TAB_ID) {
        navigate(getCOABalanceSheetRoute(workspaceId, organisationId));
        return;
      }
      navigate(getCOAProfitAndLossRoute(workspaceId, organisationId));
    },
    [navigate, organisationId, workspaceId]
  );

  return (
    <div
      className={classNames(styles.tabsContainer, styles.carbonTabsContainer)}
      style={{ top: navHeight - TABS_PADDING_PLUS_BORDER }}
    >
      <CarbonTabs
        orientation="horizontal"
        selectedTabId={isBalanceSheet ? BALANCE_SHEET_TAB_ID : PROFIT_LOSS_TAB_ID}
      >
        <TabList
          ariaLabel={intl.formatMessage({
            id: 'predict.chart_of_accounts.tabs.aria_label',
            defaultMessage: 'Chart of accounts'
          })}
          onTabChange={handleCarbonTabChange}
        >
          <Tab
            id={PROFIT_LOSS_TAB_ID}
            controls={`${PROFIT_LOSS_TAB_ID}-panel`}
            label={intl.formatMessage({
              id: 'financial_fields.type.profit_and_loss',
              defaultMessage: 'Profit & Loss'
            })}
          />
          <Tab
            id={BALANCE_SHEET_TAB_ID}
            controls={`${BALANCE_SHEET_TAB_ID}-panel`}
            label={intl.formatMessage({ id: 'financial_fields.type.balance_sheet', defaultMessage: 'Balance Sheet' })}
          />
        </TabList>
        <TabPanel id={`${PROFIT_LOSS_TAB_ID}-panel`} tabId={PROFIT_LOSS_TAB_ID} />
        <TabPanel id={`${BALANCE_SHEET_TAB_ID}-panel`} tabId={BALANCE_SHEET_TAB_ID} />
      </CarbonTabs>
    </div>
  );
};
